import { ref } from 'vue';

export function useDownloadOffer() {
  const isPending = ref(false);

  async function downloadOffer(context: { [key: string]: string }, fileName = 'oferta') {
    isPending.value = true;

    try {
      const response = await fetch('https://api.markupgo.com/api/v1/pdf', {
        method: 'POST',
        headers: {
          'x-api-key': 'aa83ce86-e40c-4211-ae6e-dbfb5c16555e',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          source: {
            type: 'template',
            data: {
              id: '66ffef897ce9f537be33e55e',
              context,
            },
          },
        }),
      });

      const result = await response.json();

      const pdfResponse = await fetch(result.url);
      const pdfBlob = await pdfResponse.blob();

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
    } catch (error) {
      console.error('Error downloading offer:', error);
    } finally {
      isPending.value = false;
    }
  }

  return { isPending, downloadOffer };
}

export function useDownloadFinancingOffer() {
  const isPending = ref(false);

  async function downloadFinancingOffer(
    context: { [key: string]: string },
    fileName = 'oferta-finansowanie'
  ) {
    isPending.value = true;

    try {
      const response = await fetch('https://api.markupgo.com/api/v1/pdf', {
        method: 'POST',
        headers: {
          'x-api-key': 'aa83ce86-e40c-4211-ae6e-dbfb5c16555e',
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          source: {
            type: 'template',
            data: {
              id: '689d7f3d386a976bae187275',
              context,
            },
          },
        }),
      });

      const result = await response.json();

      const pdfResponse = await fetch(result.url);
      const pdfBlob = await pdfResponse.blob();

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
    } catch (error) {
      console.error('Error downloading financing offer:', error);
    } finally {
      isPending.value = false;
    }
  }

  return { isPending, downloadFinancingOffer };
}
